import { ErrorResponse } from '@apollo/client/link/error'
// import { GraphQLError } from 'graphql'

export default function processApolloError (
  client: any,
  { graphQLErrors = [], networkError }: ErrorResponse
) {
  if (graphQLErrors) {
    for (const err of graphQLErrors) {
      const { message, locations, path } = err

      console.log(
        `[GraphQL error]: Message ${message}, Location: ${locations}, Path: ${path}`
      )
    }
  }

  if (networkError) console.log(`[Network error]: ${networkError}`)
}
